import React from 'react'
import DeleteIcon from '@material-ui/icons/Delete'
import { Divider, Button, Grid, Paper } from '@material-ui/core'
import moment from 'moment'

const ServicesList = ({services, deleteTask, taskType}) => {

  return (
    <Paper style={{padding: '1rem', backgroundColor: 'white', height: '100%'}}>
        <div style={{height: '100%', }}>
        {services.map((service, i)=>
        <div key={i} style={{marginBottom: '0.5rem'}}>
            <Grid  container spacing={2} >
                <Grid item md={1} >
                    {i+1}
                </Grid>
                <Grid item md={2} >
                    {moment(service.date).format('DD.MM.YYYY')}
                </Grid>
                <Grid item md={taskType==='auto' ? 2 : 2} >
                    {taskType==='auto' 
                        ? service.toMember.userName 
                        : `${service.amount.toFixed(2)}€`}
                </Grid>
                <Grid item md={taskType==='auto' ? 2 : 1} >
                    {taskType==='auto' ? service.hoursTxt : service.count}
                </Grid>
                {taskType==='auto' && <Grid item md={1} >
                    {service.km}
                </Grid>}
                <Grid item md={taskType==='auto' ? 3 : 4} >
                    {taskType==='auto' ? service.task.name : service.task}
                    {service.task.name}
                </Grid>
                 {taskType!=='auto' && 
                    <Grid item md={1} >
                        {(service.amount*service.count).toFixed(2)}€
                    </Grid>}
                <Grid item md={1} >
                    <Button onClick={()=>deleteTask(i)} size='small' color='secondary' style={{}}><DeleteIcon /></Button>
                </Grid>
            </Grid>
            <Divider />
        </div>
        )}
      </div>   
    </Paper>

  )
}



export default ServicesList
